import React from "react";
import CabinetRow from "./CabinetRow";
import { shakerData, cabinetTypes, colorCodeData, fixedPriceItems, pvcRollingShutterSizes, profileHandlePrices } from "../data/constants";

const CabinetTable = ({
  cabinets,
  country ,
  handleCabinetChange,
  handleDeleteCabinet,
  handleKeyDown,
  calculateTotal,
  calculateSqft,
  isCabinetValid,
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg border border-indigo-100 overflow-hidden slide-in">
      <div className="bg-gradient-to-r from-indigo-500 to-purple-600 p-6">
        <h2 className="text-2xl font-bold text-white flex items-center">
          <div className="w-6 h-6 bg-white rounded-full mr-3 flex items-center justify-center">
            <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
          </div>
          Cabinet Details
          <span className="ml-3 text-indigo-200 text-lg">
            ({country === "Shaker" ? "Shaker Series" : "Custom Cabinets"})
          </span>
        </h2>
        {country === "Shaker" && (
          <p className="text-indigo-100 text-sm mt-2">
            Note: Fixed-price items (Magic Corner, Lazy Susan, etc.) don't require dimensions
          </p>
        )}
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-indigo-50">
            <tr>
              <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Type</th>
              {country === "Shaker" ? (
                <>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Description</th>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Unit Cost</th>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Qty</th>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Discount</th>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Total</th>
                </>
              ) : (
                <>
                  {/* Dynamic columns for Custom Cabinets based on type */}
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Size/Width</th>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Inches/Height</th>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Color</th>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Material</th>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Sq.Ft.</th>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Drawer Slides</th>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Hinges</th>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Discount %</th>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Unit/LF</th>
                  <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Total</th>
                </>
              )}
              <th className="p-4 text-left font-semibold text-indigo-700 uppercase text-sm">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-indigo-50">
            {cabinets.map((cab, i) => (
              <CabinetRow
                key={i}
                cab={cab}
                index={i}
                country={country}
                shakerData={shakerData}
                cabinetTypes={cabinetTypes}
                colorCodeData={colorCodeData}
                fixedPriceItems={fixedPriceItems}
                pvcRollingShutterSizes={pvcRollingShutterSizes}
                profileHandlePrices={profileHandlePrices}
                handleCabinetChange={handleCabinetChange}
                handleKeyDown={handleKeyDown}
                handleDeleteCabinet={handleDeleteCabinet}
                calculateTotal={calculateTotal}
                calculateSqft={calculateSqft}
                isCabinetValid={isCabinetValid}
              />
            ))}
          </tbody>
        </table>
        
        {/* Summary information */}
      
      </div>
    </div>
  );
};

export default CabinetTable;